import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  TextField,
} from '@mui/material';
import { toFreeTextScopes, toggleScope } from './oauthCredentialForm.utils';

const LABEL_SX = { mb: 0, fontSize: '0.875rem' };

const OPTIONS_SX = {
  '& .MuiFormControlLabel-label:not(.Mui-disabled)': {
    color: 'text.primary',
  },
};

const OAuthCredentialScopes = ({
  availableScopes,
  scopes,
  error,
  disabled,
  freeText,
  sx,
  onChange,
}) => {
  if (freeText) {
    return (
      <TextField
        label='Scope'
        id='oauth_credential_scope'
        name='scopes'
        value={scopes[0] ?? ''}
        onChange={(e) => onChange(toFreeTextScopes(e.target.value))}
        disabled={disabled}
        size='small'
        fullWidth
        error={!!error}
        helperText={error}
        autoComplete='off'
        sx={sx}
      />
    );
  }

  return (
    <FormControl
      component='fieldset'
      error={!!error}
      disabled={disabled}
      sx={sx}>
      <FormLabel component='legend' sx={LABEL_SX}>
        Scopes
      </FormLabel>
      <FormGroup row sx={OPTIONS_SX}>
        {availableScopes.map((scope) => (
          <FormControlLabel
            key={scope}
            control={
              <Checkbox
                checked={scopes.includes(scope)}
                onChange={(e) =>
                  onChange(toggleScope(scopes, scope, e.target.checked))
                }
                name={scope}
                color='primary'
              />
            }
            label={scope}
          />
        ))}
      </FormGroup>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default OAuthCredentialScopes;
